import gql from 'graphql-tag';

export default gql`
  fragment FormTemplateFragment on FormTemplate {
    _id
    title
    isDefault
    creator {
      _id
    }
    data {
      course {
        _id
      }
      courseCategory {
        _id
      }
      fields {
        _id
        title
        type
        value
        formFieldItems {
          value
          label
          _id
        }
      }
    }
    createdAt
  }
`;
